import { UntitledIcon } from '@faceup/icons'
import { ulArrowLeft } from '@faceup/icons/ulArrowLeft'

export const ArrowGoBack = () => <UntitledIcon icon={ulArrowLeft} className='text-2xl text-black' />
